<div *ngIf="initialized$ | async" [@fadeAnimation]="outlet.activatedRouteData.animation || ''">
	<router-outlet #outlet="outlet"></router-outlet>
</div>
